import React from "react";
import {Typography, useTheme} from "@mui/material";

export const SectionTitle: React.FC<{ children: React.ReactNode }> = ({children}) => {
    const theme = useTheme()
    return (
        <Typography variant="overline" sx={{
            display: 'inline-block',
            fontFamily: '"DM Mono", monospace',
            fontWeight: 700, fontSize: '0.72rem', letterSpacing: '0.12em',
            color: theme.palette.text.secondary,
            borderBottom: `2px solid ${theme.palette.primary.main}`,
            pb: 0.4, mb: 2,
        }}>
            {children}
        </Typography>
    )
}